export default class AcknowledgementText {
	public textId: number | null = null;
	public isAcknowledged: boolean | null = null;

	public constructor() {

	}
};